import { IDs } from '../../../helpers/IDs';
import * as React from 'react';
import { i18n } from '../../../i18n/i18n';
import { fn2 } from '../../../core/formatter/formatNumber';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { getDefaultHelpIcon } from '../../../helpers/getDefaultHelpIcon';
import { sortObjectArrayPro } from '../../../main/functions/sortObjectArray';

interface StatistikProps extends React.ClassAttributes<any> {
    data: any;
    tabKey: string;
    statistik: any;
}

export interface StatistikState {
    offsetScrollbar: any
}

export class Statistik extends React.Component<StatistikProps, StatistikState> {

    constructor(props: any) {
        super(props);
        this.state = {
            offsetScrollbar: {}
        };
        this.tabRefs = {
            gewerk: React.createRef(),
            bundeslaender: React.createRef()
        };
    }

    private tabRefs: any;
    private arr_ents_s1_2 = ['strom', '.strom_v', '.strom_k', 'waerme', '.waerme_v', '.waerme_k', 'kraftstoffe', '.kraftstoffe_v', '.kraftstoffe_k', 'wasser', '.wasser_k', 'bwl'];
    private arr_ents_s3 = ['gueter_einkauf', 'gueter_kapital', 'transport_vorgelagert', 'abfall', 'reisen', 'pendeln', 'angemietete_sachanlagen', 'transport_nachgelagert',
        'produkte_verarbeitung', 'produkte_nutzung', 'produkte_lebenszyklus', 'vermietete_sachanlagen', 'franchise', 'investition', 'emittenten'];
    private style: any = {
        title: { marginBottom: 2, marginTop: 15, padding: 3, fontWeight: 'bold', color: '#FFF', backgroundColor: '#616468' },
        head: { color: '#000', backgroundColor: '#bccae3', margin: 1, padding: 3, fontWeight: 'bold', boxSizing: 'border-box' },
        field: { color: '#000', backgroundColor: '#EEE', margin: 1, padding: 3, textAlign: 'center', boxSizing: 'border-box' }
    }

    componentDidMount(): void {
        this.setOffsetScrollbar();
    }

    setOffsetScrollbar() {
        Object.keys(this.tabRefs).forEach((k: string) => {
            if (this.tabRefs[k].current) {
                const offset: number = this.tabRefs[k].current.parentNode.offsetWidth - this.tabRefs[k].current.clientWidth;
                const { offsetScrollbar } = this.state;
                if (offset !== offsetScrollbar[k]) {
                    offsetScrollbar[k] = offset;
                    this.setState({ offsetScrollbar });
                }
            }
        });
    }

    render(): JSX.Element {
        const { tabKey, statistik } = this.props;
        return (
            <div style={{ display: 'flex', flexDirection: 'column', padding: 15, fontSize: 12 }}>
                <div style={{ display: 'flex', flexDirection: 'row', fontSize: 12, flexWrap: 'wrap' }}>
                    {tabKey === 'handwerk' && this.renderBereich(statistik.handwerk, 'Gewerk')}
                    {tabKey === 'kultur' && this.renderBereich(statistik.kultur, 'Einrichtung (Art)')}
                    {tabKey === 'sonstige' && this.renderBereich(statistik.sonstige, 'Unternehmensart')}
                </div>
            </div>
        );
    }

    renderBereich(bereich_data: any, nameGewerk: string) {
        const styleBlock: React.CSSProperties = { minWidth: 1400, marginLeft: 15, marginTop: 30, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }; // flexWrap: 'wrap'
        const sytle1: React.CSSProperties = { display: 'flex', flexDirection: 'column' };
        const sytle2: React.CSSProperties = { textAlign: 'center', fontWeight: 'bold', fontSize: 20, marginBottom: 12 };
        const styleSmall: React.CSSProperties = { fontSize: 10 };
        return <>
            <div style={styleBlock}>
                <div style={{ ...sytle1, flex: 1 }}>
                    <div style={{ ...sytle2 }}>
                        Logins/Registrierungen
                        {this.renderHilfeBtn('registrierungen')}
                    </div>
                    {this.renderRegistrierung()}
                </div>
                <div style={{ ...sytle1, flex: 1, marginLeft: 30 }}>
                    <div style={{ ...sytle2 }}>
                        Berater
                        {this.renderHilfeBtn('berater')}
                    </div>
                    {this.renderBerater()}
                </div>
            </div>

            <div style={styleBlock}>
                <div style={{ ...sytle1, flex: 1 }}>
                    <div style={{ ...sytle2 }}>
                        Anzahl der E-Tools <span style={styleSmall}>(ohne Testtools)</span>
                        {this.renderHilfeBtn('genutzte_tools')}
                    </div>
                    {this.renderKPI(bereich_data)}
                </div>
                <div style={{ ...sytle1, flex: 1, marginLeft: 30 }}>
                    <div style={{ ...sytle2 }}>
                        Energiedatensätze Scope 1/2 <span style={styleSmall}>(ohne Testtools)</span>
                        {this.renderHilfeBtn('datensaetze_scope1-2')}
                    </div>
                    {this.renderWerte(bereich_data.statistik_user, this.arr_ents_s1_2)}
                </div>
                <div style={{ ...sytle1, flex: 1, marginLeft: 30 }}>
                    <div style={{ ...sytle2 }}>
                        Energiedatensätze Scope 3 <span style={styleSmall}>(ohne Testtools)</span>
                        {this.renderHilfeBtn('datensaetze_scope3')}
                    </div>
                    {this.renderWerte(bereich_data.statistik_user, this.arr_ents_s3)}
                </div>
            </div>

            <div style={styleBlock}>
                <div style={{ ...sytle1, flex: 1 }}>
                    <div style={{ ...sytle2 }}>
                        Ranking {nameGewerk}
                        {this.renderHilfeBtn(nameGewerk)}
                    </div>
                    {this.renderRanking(bereich_data.ranking.gewerk, 'gewerk_tid', IDs.ENT_BRANCHEN_GEWERKE)}
                </div>
                <div style={{ ...sytle1, flex: 1, marginLeft: 30 }}>
                    <div style={{ ...sytle2 }}>
                        Ranking Bundesländer
                        {this.renderHilfeBtn('ranking_bundeslaender')}
                    </div>
                    {this.renderRanking(bereich_data.ranking.bundesland, 'bundesland', IDs.ENT_BUNDESLAND)}
                </div>
                <div style={{ ...sytle1, flex: 1, marginLeft: 30 }}>
                    <div style={{ ...sytle2 }}>
                        System
                        {this.renderHilfeBtn('system')}
                    </div>
                    {this.renderSystem(bereich_data)}
                </div>
            </div>

            <div style={styleBlock}>
                <div style={{ ...sytle1, flex: 1 }}>
                    <div style={{ ...sytle2 }}>
                        Spezialfrage: Steuerrückerstattung
                        {this.renderHilfeBtn('steuerrueckerstattung')}
                    </div>
                    {this.renderSteuerrueckerstattung(bereich_data)}
                </div>
                <div style={{ ...sytle1, flex: 1, marginLeft: 30 }}>

                </div>
                <div style={{ ...sytle1, flex: 1, marginLeft: 30 }}>

                </div>
            </div>
        </>;
    }

    renderWerte(values: any, arr_ents: Array<string>) {
        const arr_ranges = Object.keys(values);
        const field_style: React.CSSProperties = { ...this.style.field, flex: 1 };
        let head_style: React.CSSProperties = { ...this.style.head, flex: 3 };
        return <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ ...head_style }}>Art</div>
                {arr_ranges.map((r: string) => <div style={{ ...head_style, flex: 1, textAlign: 'center', fontWeight: 'bold' }}>{r === 'all' ? 'Gesamt' : r} </div>)}
            </div>
            {arr_ents.map((e: string) => {
                let stHead: React.CSSProperties = { ...head_style, backgroundColor: field_style.backgroundColor };
                let stHead2: React.CSSProperties = {};
                if (e.startsWith('.')) {
                    // Die zweite Ebene
                    stHead = { ...stHead, fontWeight: 'normal' };
                    stHead2 = { marginLeft: 30, };
                }
                return <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={stHead}><div style={stHead2}>{i18n(e)}</div></div>
                    {arr_ranges.map((r: string) => <div style={{ ...field_style }}>
                        {(values[r] && values[r][e]) ? values[r][e] : '-'}
                    </div>)}
                </div>;
            })}
        </div>;
    }

    renderRanking(values: Array<any>, field: string, entity: string) {
        const field_style: React.CSSProperties = { ...this.style.field };
        const head_style: React.CSSProperties = { ...this.style.head };
        // Sortieren values nach Namen
        values.forEach((v: any) => {
            const name = this.getCatalogItemName(+v[field], entity);
            v[field + '_name'] = name;
            v[field + '_compare'] = this.getComparableText(name);
        });
        sortObjectArrayPro(values, [{ key: 'cnt', desc: true }, { key: field + '_compare' }]);
        const refKey = entity === IDs.ENT_BRANCHEN_GEWERKE ? 'gewerk' :
            entity === IDs.ENT_BUNDESLAND ? 'bundeslaender' :
                null;
        return <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{
                display: 'flex', flexDirection: 'row',
                ...refKey && this.state.offsetScrollbar[refKey] > 0 ? { width: `calc(100% - ${this.state.offsetScrollbar[refKey]}px)` } : {}
            }}>
                <div style={{ ...head_style, flex: 3 }}>Bezeichnung</div>
                <div style={{ ...head_style, flex: 1, textAlign: 'center' }}>Anzahl</div>
            </div>
            <div
                style={{ maxHeight: 400, overflowY: 'auto', scrollbarWidth: 'thin' }}
                ref={refKey ? this.tabRefs[refKey] : null}
            >
                {values.map((v: any) => <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ ...head_style, flex: 3, backgroundColor: field_style.backgroundColor }}>{v[field + '_name']}</div>
                    <div style={{ ...field_style, flex: 1 }}>{v.cnt}</div>
                </div>)}
            </div>
        </div>;
    }

    renderKPI(data: any) {
        const field_style: React.CSSProperties = { ...this.style.field };
        const head_style: React.CSSProperties = { ...this.style.head };
        const rowSytle1: React.CSSProperties = { ...head_style, flex: 3, backgroundColor: field_style.backgroundColor };
        const rowStyle2: React.CSSProperties = { ...field_style, flex: 1 };
        const rowSytle3: React.CSSProperties = { ...head_style, flex: 3, backgroundColor: field_style.backgroundColor, fontWeight: 'normal' };
        const rowSytle3a: React.CSSProperties = { marginLeft: 30 };
        const styleSmall: React.CSSProperties = { fontSize: 10 };
        const kpi = data.kpi || {};
        const zusatz = data.zusatz || {};
        return <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ ...head_style, flex: 3 }}>Bezeichnung</div>
                <div style={{ ...head_style, flex: 1, textAlign: 'center' }}>Anzahl</div>
            </div>
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle1}>E-Tool Nutzer</div>
                    <div style={rowStyle2}>{kpi.used || '-'}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle1}>Vollständige E-Tools <span style={styleSmall}>(Strom & Wärme)</span></div>
                    <div style={rowStyle2}>{kpi.complete1 || '-'}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle1}>Vollständige E-Tools <span style={styleSmall}>(Strom, Wärme & Kraftstoffe)</span></div>
                    <div style={rowStyle2}>{kpi.complete2 || '-'}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle1}>Zusatztools</div>
                    <div style={rowStyle2}></div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle3}><div style={rowSytle3a}>Dokumentenablage</div></div>
                    <div style={rowStyle2}>{zusatz.dokument || '-'}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle3}><div style={rowSytle3a}>Entwicklungsfahrplan</div></div>
                    <div style={rowStyle2}>{zusatz.entwicklungsfahrplan || '-'}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle3}><div style={rowSytle3a}>Zertifizierung</div></div>
                    <div style={rowStyle2}>{zusatz.zertifizierung || '-'}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle3}><div style={rowSytle3a}>Lastgang</div></div>
                    <div style={rowStyle2}>{zusatz.lastgang || '-'}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle3}><div style={rowSytle3a}>PV-Tool</div></div>
                    <div style={rowStyle2}>{zusatz.pvtool || '-'}</div>
                </div>
            </div>
        </div>;
    }

    renderRegistrierung() {
        const { tabKey, statistik } = this.props;
        const field_style: React.CSSProperties = { ...this.style.field, flex: 1 };
        const head_style: React.CSSProperties = { ...this.style.head, flex: 3 };
        const row_head_style: React.CSSProperties = { ...head_style, backgroundColor: field_style.backgroundColor };
        const arr_ranges = ['7', '30', '90', '365', 'all'];
        const dataRll = statistik.handwerk.statistik_admin.registrierungen_last_login;
        const dataRr = statistik.handwerk.statistik_admin.registrierungen_registration;
        const bereich = ['handwerk', 'kultur', 'sonstige'].indexOf(tabKey) >= 0 ? tabKey : null;

        if (!bereich) {
            return null;
        }
        return <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ ...head_style }}>Art</div>
                    {arr_ranges.map((r: string) => <div style={{ ...head_style, textAlign: 'center', flex: 1 }}>{r === 'all' ? 'Gesamt' : '< ' + r + ' Tage'} </div>)}
                    <div style={{ ...head_style, textAlign: 'center', flex: 2 }}>Durchschnittliche Anzahl der Logins</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={row_head_style}>Zuletzt eingeloggt <span style={{ fontSize: 10 }}>(Anwender-Tools)</span></div>
                    {arr_ranges.map((r: string) => <div style={{ ...field_style }}>
                        {(dataRll[r] && dataRll[r][0] && dataRll[r][0][bereich]) ? dataRll[r][0][bereich] : '-'}
                    </div>)}
                    <div style={{ ...field_style, flex: 2 }}>
                        {dataRll['365'] && dataRll['365'][0] && dataRll['365'][0][bereich] > 0 && dataRll['all'] && dataRll['all'][0] && dataRll['all'][0][bereich] > 0 ?
                            fn2(dataRll['365'][0][bereich] / dataRll['all'][0][bereich]) : '-'}
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={row_head_style}>Zuletzt eingeloggt <span style={{ fontSize: 10 }}>(Test-Tools)</span></div>
                    {arr_ranges.map((r: string) => <div style={{ ...field_style }}>
                        {(dataRll[r] && dataRll[r][1] && dataRll[r][1][bereich]) ? dataRll[r][1][bereich] : '-'}
                    </div>)}
                    <div style={{ ...field_style, flex: 2 }}>
                        {dataRll['365'] && dataRll['365'][1] && dataRll['365'][1][bereich] > 0 && dataRll['all'] && dataRll['all'][1] && dataRll['all'][1][bereich] > 0 ?
                            fn2(dataRll['365'][1][bereich] / dataRll['all'][1][bereich]) : '-'}
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={row_head_style}>Registriert <span style={{ fontSize: 10 }}>(Anwender-Tools)</span></div>
                    {arr_ranges.map((r: string) => <div style={{ ...field_style }}>
                        {(dataRr[r] && dataRr[r][0] && dataRr[r][0][bereich]) ? dataRr[r][0][bereich] : '-'}
                    </div>)}
                    <div style={{ ...field_style, flex: 2 }}>
                        {dataRr['365'] && dataRr['365'][0] && dataRr['365'][0][bereich] > 0 && dataRr['all'] && dataRr['all'][0] && dataRr['all'][0][bereich] > 0 ?
                            fn2(dataRr['365'][0][bereich] / dataRr['all'][0][bereich]) : '-'}
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={row_head_style}>Registriert <span style={{ fontSize: 10 }}>(Test-Tools)</span></div>
                    {arr_ranges.map((r: string) => <div style={{ ...field_style }}>
                        {(dataRr[r] && dataRr[r][1] && dataRr[r][1][bereich]) ? dataRr[r][1][bereich] : '-'}
                    </div>)}
                    <div style={{ ...field_style, flex: 2 }}>
                        {dataRr['365'] && dataRr['365'][1] && dataRr['365'][1][bereich] > 0 && dataRr['all'] && dataRr['all'][1] && dataRr['all'][1][bereich] > 0 ?
                            fn2(dataRr['365'][1][bereich] / dataRr['all'][1][bereich]) : '-'}
                    </div>
                </div>
            </div>
        </div>;
    }

    renderBerater() {
        const { tabKey, statistik } = this.props;
        const field_style: React.CSSProperties = { ...this.style.field, flex: 1 };
        const head_style: React.CSSProperties = { ...this.style.head, flex: 3 };
        const row_head_style: React.CSSProperties = { ...head_style, backgroundColor: field_style.backgroundColor };
        const arr_ranges = ['7', '30', '90', '365', 'all'];
        const dL = statistik.handwerk.statistik_admin.berater_login;
        const dR = statistik.handwerk.statistik_admin.berater_angelegt;
        const bereich = ['handwerk', 'kultur', 'sonstige'].indexOf(tabKey) >= 0 ? tabKey : null;

        if (!bereich) {
            return null;
        }
        return <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ ...head_style }}>Art</div>
                    {arr_ranges.map((r: string) => <div style={{ ...head_style, textAlign: 'center', flex: 1 }}>{r === 'all' ? 'Gesamt' : '< ' + r + ' Tage'} </div>)}
                    <div style={{ ...head_style, textAlign: 'center', flex: 2 }}>Durchschnittlich zugeordnete Anzahl von E-Tools</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={row_head_style}>Zuletzt eingeloggt <span style={{ fontSize: 10 }}>(HWK)</span></div>
                    {arr_ranges.map((r: string) => <div style={{ ...field_style }}>
                        {dL[r] && dL[r][0] && dL[r][0][bereich] && dL[r][0][bereich].cnt ? dL[r][0][bereich].cnt : '-'}
                    </div>)}
                    <div style={{ ...field_style, flex: 2 }}>
                        {dL.all && dL.all[0] && dL.all[0][bereich] && dL.all[0][bereich].cnt && dL.all[0][bereich].cnt_z ?
                            // dL.all[0][bereich].cnt_z + ' / ' +
                            fn2(dL.all[0][bereich].cnt_z / dL.all[0][bereich].cnt) : '-'}
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={row_head_style}>Zuletzt eingeloggt <span style={{ fontSize: 10 }}>(Extern)</span></div>
                    {arr_ranges.map((r: string) => <div style={{ ...field_style }}>
                        {dL[r] && dL[r][1] && dL[r][1][bereich] && dL[r][1][bereich].cnt ? dL[r][1][bereich].cnt : '-'}
                    </div>)}
                    <div style={{ ...field_style, flex: 2 }}>
                        {dL.all && dL.all[1] && dL.all[1][bereich] && dL.all[1][bereich].cnt && dL.all[1][bereich].cnt_z ?
                            // dL.all[1][bereich].cnt_z + ' / ' +
                            fn2(dL.all[1][bereich].cnt_z / dL.all[1][bereich].cnt) : '-'}
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={row_head_style}>Registriert <span style={{ fontSize: 10 }}>(HWK)</span></div>
                    {arr_ranges.map((r: string) => <div style={{ ...field_style }}>
                        {dR[r] && dR[r][0] && dR[r][0][bereich] && dR[r][0][bereich].cnt ? dR[r][0][bereich].cnt : '-'}
                    </div>)}
                    <div style={{ ...field_style, flex: 2 }}>
                        {dR.all && dR.all[0] && dR.all[0][bereich] && dR.all[0][bereich].cnt && dR.all[0][bereich].cnt_z ?
                            // dR.all[0][bereich].cnt_z + ' / ' +
                            fn2(dR.all[0][bereich].cnt_z / dR.all[0][bereich].cnt) : '-'}
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={row_head_style}>Registriert <span style={{ fontSize: 10 }}>(Extern)</span></div>
                    {arr_ranges.map((r: string) => <div style={{ ...field_style }}>
                        {dR[r] && dR[r][1] && dR[r][1][bereich] && dR[r][1][bereich].cnt ? dR[r][1][bereich].cnt : '-'}
                    </div>)}
                    <div style={{ ...field_style, flex: 2 }}>
                        {dR.all && dR.all[1] && dR.all[1][bereich] && dR.all[1][bereich].cnt && dR.all[1][bereich].cnt_z ?
                            // dR.all[1][bereich].cnt_z + ' / ' +
                            fn2(dR.all[1][bereich].cnt_z / dR.all[1][bereich].cnt) : '-'}
                    </div>
                </div>
            </div>
        </div>;
    }

    getCatalogItemName(tid: number, entity: string) {
        const catalog = this.props.data[entity];
        if (!tid) {
            return <i>Keine Angabe</i>;
        }
        let name = 'ID: ' + tid;
        if (catalog) {
            const found = catalog.find((item: any) => item.tid === tid);
            if (found) {
                name = found.name;
            }
        }
        return name;
    }

    renderHilfeBtn(key: string, title?: string) {
        const { data } = this.props;
        const helpKey = [RoutingIDs.TABS_STATISTIK, key].join('.').toLowerCase();
        // console.log(helpKey);
        return getDefaultHelpIcon(helpKey, title, data, null, { marginTop: 2, }, { position: 'unset', marginTop: 0, marginLeft: 10 });
    }

    getComparableText(text: any) {
        text = typeof text === 'string' ? text.trim().toLocaleLowerCase() : '';
        text = text.replace(/ä/g, 'ae');
        text = text.replace(/ö/g, 'oe');
        text = text.replace(/ü/g, 'ue');
        text = text.replace(/ß/g, 'ss');
        return text;
    }

    // renderSystem() {
    //     const { statistik } = this.props;
    //     return <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 200, flex: 1, marginLeft: 15, textAlign: 'center' }}>
    //         <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 200, textAlign: 'center', backgroundColor: '#EEF', marginTop: 15 }}>
    //             <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '14px', marginTop: 15 }}> Speicher (Handwerk)</div>
    //             <div style={{ marginTop: 10 }}>
    //                 <b>Belegt:</b> {fn2(statistik.handwerk.server.disk_usage)}% &nbsp;
    //                 <b>Frei:</b> {fn2(statistik.handwerk.server.disk_free / (1024 * 1024 * 1024))} GB
    //             </div>
    //             <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '14px', marginTop: 15 }}> Speicher (Kultur)</div>
    //             <div style={{ marginTop: 10, marginBottom: 15 }}>
    //                 <b>Belegt:</b> {fn2(statistik.kultur.server.disk_usage)}% &nbsp;
    //                 <b>Frei:</b> {fn2(statistik.kultur.server.disk_free / (1024 * 1024 * 1024))} GB
    //             </div>
    //         </div>
    //     </div>;
    // }

    renderSystem(data: any) {
        const field_style: React.CSSProperties = { ...this.style.field };
        const head_style: React.CSSProperties = { ...this.style.head };
        const rowSytle1: React.CSSProperties = { ...head_style, flex: 2, backgroundColor: field_style.backgroundColor };
        const rowStyle2: React.CSSProperties = { ...field_style, flex: 1 };
        const rowSytle3: React.CSSProperties = { ...head_style, flex: 2, backgroundColor: field_style.backgroundColor, fontWeight: 'normal' };
        const rowSytle3a: React.CSSProperties = { marginLeft: 30 };

        return <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ ...head_style, flex: 2 }}>Bezeichnung</div>
                <div style={{ ...head_style, flex: 1, textAlign: 'center' }}>Anzahl</div>
            </div>
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle1}>Speicher</div>
                    <div style={rowStyle2}></div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle3}><div style={rowSytle3a}>Belegt</div></div>
                    <div style={rowStyle2}>{fn2(data.server.disk_usage)}%</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle3}><div style={rowSytle3a}>Frei</div></div>
                    <div style={rowStyle2}>{fn2(data.server.disk_free / (1024 * 1024 * 1024))} GB</div>
                </div>
            </div>
        </div>;
    }

    renderSteuerrueckerstattung(data: any) {
        const field_style: React.CSSProperties = { ...this.style.field };
        const head_style: React.CSSProperties = { ...this.style.head };
        const rowSytle1: React.CSSProperties = { ...head_style, flex: 2, backgroundColor: field_style.backgroundColor };
        const rowStyle2: React.CSSProperties = { ...field_style, flex: 1 };

        return <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ ...head_style, flex: 2 }}>Vor 2024</div>
                <div style={{ ...head_style, flex: 1, textAlign: 'center' }}>Minimalwert</div>
                <div style={{ ...head_style, flex: 1, textAlign: 'center' }}>Durchschnitt</div>
                <div style={{ ...head_style, flex: 1, textAlign: 'center' }}>Maximalwert</div>
            </div>
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle1}>Strom</div>
                    <div style={rowStyle2}>{data.steuer.strom[2023] ? fn2(data.steuer.strom[2023].min) : '-'}</div>
                    <div style={rowStyle2}>{data.steuer.strom[2023] ? fn2(data.steuer.strom[2023].mean) : '-'}</div>
                    <div style={rowStyle2}>{data.steuer.strom[2023] ? fn2(data.steuer.strom[2023].max) : '-'}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle1}>Wärme</div>
                    <div style={rowStyle2}>{data.steuer.waerme[2023] ? fn2(data.steuer.waerme[2023].min) : '-'}</div>
                    <div style={rowStyle2}>{data.steuer.waerme[2023] ? fn2(data.steuer.waerme[2023].mean) : '-'}</div>
                    <div style={rowStyle2}>{data.steuer.waerme[2023] ? fn2(data.steuer.waerme[2023].max) : '-'}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle1}>Gesamt (Strom + Wärme)</div>
                    <div style={rowStyle2}>{data.steuer.gesamt[2023] ? fn2(data.steuer.gesamt[2023].min) : '-'}</div>
                    <div style={rowStyle2}>{data.steuer.gesamt[2023] ? fn2(data.steuer.gesamt[2023].mean) : '-'}</div>
                    <div style={rowStyle2}>{data.steuer.gesamt[2023] ? fn2(data.steuer.gesamt[2023].max) : '-'}</div>
                </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', marginTop: 15 }}>
                <div style={{ ...head_style, flex: 2 }}>Ab 2024</div>
                <div style={{ ...head_style, flex: 1, textAlign: 'center' }}>Minimalwert</div>
                <div style={{ ...head_style, flex: 1, textAlign: 'center' }}>Durchschnitt</div>
                <div style={{ ...head_style, flex: 1, textAlign: 'center' }}>Maximalwert</div>
            </div>
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle1}>Strom</div>
                    <div style={rowStyle2}>{data.steuer.strom[2024] ? fn2(data.steuer.strom[2024].min) : '-'}</div>
                    <div style={rowStyle2}>{data.steuer.strom[2024] ? fn2(data.steuer.strom[2024].mean) : '-'}</div>
                    <div style={rowStyle2}>{data.steuer.strom[2024] ? fn2(data.steuer.strom[2024].max) : '-'}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle1}>Wärme</div>
                    <div style={rowStyle2}>{data.steuer.waerme[2024] ? fn2(data.steuer.waerme[2024].min) : '-'}</div>
                    <div style={rowStyle2}>{data.steuer.waerme[2024] ? fn2(data.steuer.waerme[2024].mean) : '-'}</div>
                    <div style={rowStyle2}>{data.steuer.waerme[2024] ? fn2(data.steuer.waerme[2024].max) : '-'}</div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={rowSytle1}>Gesamt (Strom + Wärme)</div>
                    <div style={rowStyle2}>{data.steuer.gesamt[2024] ? fn2(data.steuer.gesamt[2024].min) : '-'}</div>
                    <div style={rowStyle2}>{data.steuer.gesamt[2024] ? fn2(data.steuer.gesamt[2024].mean) : '-'}</div>
                    <div style={rowStyle2}>{data.steuer.gesamt[2024] ? fn2(data.steuer.gesamt[2024].max) : '-'}</div>
                </div>
            </div>
        </div>;
    }
}
